import { appConfig } from '@src/config/appConfig';
import { getDimensionsImage } from '@src/utils/imageUtils';
import {
  isStickerImageTypeAllowed,
  MAX_ALLOWED_HEIGHT_STICKER,
  MAX_ALLOWED_SIZE_STICKER,
  MAX_ALLOWED_WIDTH_STICKER,
} from '@src/utils/mediaUtils';
import { EmojiClickData } from 'emoji-picker-react';
import {
  AddOwnStickersButtonId,
  MaximumSuggestedListSize,
  StickersKeyName,
  SuggestedLocalStorageId,
} from './constants';

const urlBase = '/resources/stickers/';
const customStickerPosfix = '.custom';

const folderNames = [
  'good-morning-quaroutine-greetings',
  'ikblijfmeedoen',
  'me-emoji',
  'b2chat',
];

export const NOT_FOUND_ERROR = 'Sticker not found';

export const urlToObject = async (emojiObj: EmojiClickData) => {
  const { emoji, imageUrl } = emojiObj;

  if (emoji.search(customStickerPosfix) !== -1) {
    let url = urlBase;
    folderNames.forEach(name => {
      if (emoji.startsWith(name)) url += name;
    });
    const [stickerName] = imageUrl.split('/').slice(-1);
    url += `/${stickerName.split('.')[0]}.webp`;
    try {
      const response = await fetch(url);
      const blob = await response.blob();
      const file = new File([blob], 'sticker.webp', {
        type: blob.type,
      });
      return file;
    } catch (error) {
      return error as Error;
    }
  } else {
    // get base64 file from localStorage
    const fileUrl = (appConfig.getData(emoji) || '') as string;
    const match = fileUrl.match(/^data:(.+?);base64,(.*)$/);
    if (!match) return new Error(NOT_FOUND_ERROR);

    const mimeType = match[1];
    const binary = atob(match[2]);
    const u8arr = Uint8Array.from(binary, char => char.charCodeAt(0));
    const file = new File([u8arr], 'sticker.webp', {
      type: mimeType,
    });
    return file;
  }
};

export const fileToBase64 = (file: File) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.readAsDataURL(file);
    reader.onload = () => resolve(reader.result);
    reader.onerror = reject;
  });

export const validateFile = async (file: File) => {
  const { type, size } = file;
  if (!isStickerImageTypeAllowed(type) || size > MAX_ALLOWED_SIZE_STICKER)
    return false;

  const dimensionsImage = await getDimensionsImage(file);

  return (
    dimensionsImage.width === MAX_ALLOWED_WIDTH_STICKER &&
    dimensionsImage.height === MAX_ALLOWED_HEIGHT_STICKER
  );
};

export const getCustomStickerArr = () =>
  appConfig.getData(StickersKeyName) || [];

// Note: remove sticker 'plus' from suggested list and limit size to 14
export const filterSuggestedItems = () => {
  const items = appConfig.getData(SuggestedLocalStorageId) as {
    unified: string;
  }[];
  if (!items) return;
  const filtered = items.filter(
    item => !item.unified.startsWith(AddOwnStickersButtonId)
  );
  appConfig.setData(
    SuggestedLocalStorageId,
    filtered.slice(0, MaximumSuggestedListSize)
  );
};

export default urlToObject;
